import {GenericSelect} from '@hm/fundamental'
import React, {useState} from 'react'

import {Option} from '../common/AutoSelectDropdown'
import {useTranslation} from '../hooks/useTranslation'

type RoleCommentCategoryLookupSelect = {
  onChange: (commentCategory: string) => void
  dataScopeName: string
  disabled: boolean
  options?: Option[]
}

export const RoleCommentCategoryLookupSelect = ({
  dataScopeName,
  disabled,
  onChange,
  options,
  ...props
}: RoleCommentCategoryLookupSelect) => {
  const {t} = useTranslation()

  const [text, setText] = useState('')

  const handleChange = (text: string) => {
    if (text.trim().length !== 0) {
      onChange(text)
    }
    setText(text)
  }

  return (
    <GenericSelect
      {...props}
      name={`roleAssignment.dataScope.${dataScopeName}`}
      label={t(`roleAssignment.dataScope.${dataScopeName}`)}
      data-cy={`${dataScopeName}-textField`}
      value={text}
      setValue={(value) => handleChange(value.toString())}
      type="search"
      isDisabled={disabled}
      isTouched={true}
      values={options}
      className="w-full"
    />
  )
}
